import React, {useState} from 'react'
import {Row, Col, Button, Modal} from 'react-bootstrap'
import {CaretRight/*, Lock*/} from 'react-bootstrap-icons'
import ReactTooltip from 'react-tooltip'
import materialtextures from './config/material.json'
import TextureSelectionPad from './TextureSelectorPad' 
import FloorConfigurationPad from './FloorConfigurationPad'
import HelpTip from './HelpTip'
import './css/ConfiguratorPads.css'

export default function SelectionPanel (props) 
{
    const [openFloorNumber, setOpenFloorNumber] = useState(props.openFloorSection);
    const [floorNumberLocked, setFloorNumberLocked] = useState(false);
    const [openStructure, setOpenStructure] = useState(false) ;
    const [openFloorConfig, setOpenFloorConfig] = useState(false) ;
    const [showConfirm, setShowConfirm] = useState(false);
 
    const handleFloorCount = ()=>{
        setOpenFloorNumber( !floorNumberLocked && !openFloorNumber);
    }

    const handleFloorConfig = ()=>{
        //setFloorNumberLocked( true );
        setOpenFloorNumber( false );
        setOpenStructure( false );
        setOpenFloorConfig( !openFloorConfig);
    }

    const handleStructure = ()=>{
        setOpenFloorNumber( false );
        setOpenFloorConfig( false );
        setOpenStructure( !openStructure );
    }

    const handleUnlockFloorNumber = e=>{
        setFloorNumberLocked( false );
        setOpenFloorNumber( true );
        setOpenFloorConfig( false );
        setShowConfirm( false );
    }

    const handlePressFloorNum = e=>{
        props.onChangeFloorNum(e.target.dataset.num);
        setOpenFloorNumber( false );
        setOpenStructure( true );
        setOpenFloorConfig( false );
    }

    
    const StructureThumb = ()=>{
        const m = props.config.structure.material;
        const t = props.config.structure.texture;
        const panelstyle = {backgroundColor: materialtextures[m][t]};
                                    
        return(
            <>
                <div 
                    data-item='structure'
                    style={panelstyle}
                    data-texture={{'texture': materialtextures[m][t], 'type': props.config.structure.type, 'material': m }}
                    className='thumbnail'
                    onClick={handleStructure}
                    data-tip
                    data-for='texttip-structure'
                />
                <ReactTooltip id='texttip-structure' place='right' effect='solid'>
                    {`${t} [${m}]`}
                </ReactTooltip>
            </>
        )
    };

    const handleChangeStructureColor = config=>{
        let c = JSON.parse(config);
        let newconfig = props.config.structure;
        newconfig.material = c.material;
        newconfig.texture = c.texture;
        props.updateSectionConfig( 'structure', newconfig );
    };

    const handleFloorsConfig = config=>{
        let c = JSON.parse(config);
        props.updateSectionConfig( 'floors', c );
    };

    const currFloorCount = props.config.floors.length;

    const floorCountSelector = [2,3,4,5,6].map(k=>{
        return(
            <div key={k} 
                 className={currFloorCount===k?' select':''}
                 data-num={k}
                 onClick={handlePressFloorNum}
            >{k}</div>
        )
    });

    return (
        <div className='overlay'>
            <div className='p-2 texture-selector-container'>
                <Row className='col-12 border-bottom border-muted'>
                    <Col className='col-12'>
                        <h4 className='text-enhanced'>
                            LIFT
                            <HelpTip />
                        </h4>

                    </Col>
                </Row>
                <Row className={`col-12 text-white border-bottom border-secondary' tex-selected':null}`}>
                    <Col className='col-4 p-2'>
                        <h5 className="conf-title" onClick={handleFloorCount} data-item="screen">FLOORS COUNT</h5>
                    </Col>
                    <Col className='col-6 p-2'>
                        <h5 className='leggera-open-btn'>
                            <CaretRight className={openFloorNumber?' deg90':null} data-item="floorNumber" onClick={handleFloorCount}/>
                        </h5>
                    </Col>
                    <Col className='col-2 p-2'>
                        <h4 className='text-enhanced' onClick={handleFloorCount}>
                            {currFloorCount} 
                            {/*floorNumberLocked?<><Lock onClick={e=>setShowConfirm(true)} style={{cursor: 'pointer'}} data-tip data-for='locktip'/>
                                <ReactTooltip id='locktip' place="top" effect="solid">Click to Unlock</ReactTooltip> </> :null*/}
                        </h4>
                    </Col>
                    {openFloorNumber?
                        <h4 className='d-flex p-2 leggera-floor-count-selector' style={{marginLeft: '7rem'}}>
                            {floorCountSelector}
                        </h4>
                    :null}
                </Row>
                <Row className={`col-12 text-white border-bottom border-secondary' tex-selected':null}`}>
                    <Col className='col-4 p-2'>
                        <h5 className="conf-title" onClick={handleStructure} data-item="screen">STRUCTURE</h5>
                    </Col>
                    <Col className='col-6 p-2'>
                        <h5 className='leggera-open-btn'>
                            <CaretRight className={openStructure?' deg90':null} data-item="floorNumber" onClick={handleStructure}/>
                        </h5>
                    </Col>
                    <Col className='col-2 p-2'>
                        <StructureThumb />
                    </Col>
                    {openStructure?
                        <TextureSelectionPad 
                            sections={['alluminium','steel']}
                            select={handleChangeStructureColor}
                        />
                        :null}
                </Row>
                <Row className={`col-12 text-white border-bottom border-secondary' tex-selected':null}`}>
                    <Col className='col-4 p-2'>
                        <h5 className="conf-title" onClick={handleFloorConfig} data-item="screen">FLOORS CONFIG</h5>
                    </Col>
                    <Col className='col-6 p-2'>
                        <h5 className='leggera-open-btn'>
                            <CaretRight className={openFloorConfig?' deg90':null} data-item="floorNumber" onClick={handleFloorConfig}/>
                        </h5>
                    </Col>
                    <Col className='col-2 p-2'>
                    </Col>
                    {openFloorConfig?
                        <FloorConfigurationPad 
                            floors={props.config.floors}
                            update={handleFloorsConfig}
                        />
                        :null
                    }
                </Row>
            </div>

            <Modal show={showConfirm} onHide={e=>setShowConfirm(false)}>
                <Modal.Header closeButton on>
                    <Modal.Title>WARNING</Modal.Title>
                </Modal.Header>
                
                <Modal.Body>
                    <p>Attention: reduce the number of floors may cause you to lose the last floors customizations</p>
                </Modal.Body>
                
                <Modal.Footer>
                    <Button variant="secondary" onClick={e=>setShowConfirm(false)}>Cancel</Button>
                    <Button variant="primary" onClick={handleUnlockFloorNumber}>Continue</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

